export const assetPath = (url: string) => {
  // return process.env.PUBLIC_URL + "/assets" + url;
  return process.env.PUBLIC_URL + "/assets" + url;
};

export const clamp = (val: number, valMin: number = 0, valMax: number = 1) => {
  let valReturn = val;
  if (valReturn < valMin) {
    valReturn = valMin;
  } else if (valReturn > valMax) {
    valReturn = valMax;
  }
  return valReturn;
}

// start, target, progress
export const lerp = (a: number, b: number, n: number) => (1 - n) * a + n * b;
